import {createSlice} from '@reduxjs/toolkit'

export const popupSlice = createSlice({
    name: 'popup',
    initialState: {
        activePopup: null
    },
    reducers: {
        setActivePopup: (state, {payload}) => {
            state.activePopup = payload
        }
    }
})

export const {setActivePopup} = popupSlice.actions

export default popupSlice.reducer
